import { render, staticRenderFns } from "./assignment-detail.vue?vue&type=template&id=7b620ade&scoped=true&"
import script from "./assignment-detail.vue?vue&type=script&lang=js&"
export * from "./assignment-detail.vue?vue&type=script&lang=js&"
import style0 from "./assignment-detail.vue?vue&type=style&index=0&id=7b620ade&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b620ade",
  null
  
)

export default component.exports